import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './Footer.scss';

export interface FooterProps {
  noContactUs?: boolean;
}

const Footer: FC<FooterProps> = ({ noContactUs }) => {
  const { t } = useTranslation();

  return (
    <footer className="enkrateia-footer">
      <a href={t('common.footer.links.privacy.url')} target="_blank" rel="noreferrer">
        {t('common.footer.links.privacy.title')}
      </a>
      <span>|</span>
      <a href={t('common.footer.links.terms.url')} target="_blank" rel="noreferrer">
        {t('common.footer.links.terms.title')}
      </a>
      {!noContactUs && (
        <>
          <span>|</span>
          <a href={t('common.footer.links.contact.url')} target="_blank" rel="noreferrer">
            {t('common.footer.links.contact.title')}
          </a>
        </>
      )}
    </footer>
  );
};

export default Footer;
